import * as React from 'react'
const GoogleIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    viewBox="0 0 33 33"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.5 16.9555C32.5 15.821 32.3961 14.7301 32.2032 13.6828H16.8265V19.8719H25.6132C25.2347 21.8719 24.0844 23.5664 22.3553 24.7009V28.7155H27.6317C30.7189 25.93 32.5 21.8282 32.5 16.9555Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8265 32.5917C21.2347 32.5917 24.9304 31.1591 27.6317 28.7155L22.3553 24.7009C20.8933 25.6609 19.0232 26.2281 16.8265 26.2281C12.5742 26.2281 8.97497 23.4136 7.69111 19.6318H2.23656V23.7772C4.92302 29.0063 10.4444 32.5917 16.8265 32.5917Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.69111 19.6318C7.36458 18.6718 7.17904 17.6464 7.17904 16.5919C7.17904 15.5373 7.36457 14.5119 7.6911 13.5519V9.40641H2.23655C1.1308 11.5664 0.5 14.01 0.5 16.5919C0.5 19.1737 1.13081 21.6172 2.23656 23.7772L7.69111 19.6318Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8265 6.95543C19.2236 6.95543 21.3757 7.7627 23.0677 9.34815L27.7505 4.75906C24.923 2.17725 21.2273 0.591797 16.8265 0.591797C10.4444 0.591797 4.92301 4.17733 2.23655 9.40641L7.6911 13.5519C8.97496 9.77005 12.5742 6.95543 16.8265 6.95543Z"
      fill="#EA4335"
    />
  </svg>
)
export default GoogleIcon
